<cb-dialog dialogHeading="{{ (isEdit$ | async) ? 'Edit Takeoff' : 'Create Takeoff' }}">
    <form class="flex-col flex" #form="ngForm">
        <div *cbWaitFor="(qsTeamMembers$ | async) && mappedItem">
            <cb-user-autocomplete-scroller
                class="flex-initial"
                label="Assigned To"
                name="assignedToUserId"
                [(ngModel)]="selectedUser"
                [requireMatch]="true"
                [matchProps]="['id']"
                [team]="QS_TEAM"
                [active]="true"
                (ngModelChange)="onUserChange($event)"
                [required]="true"
            >
            </cb-user-autocomplete-scroller>
            @if ((pricingComplexities$ | async)?.length > 0) {
                <cb-select
                    label="Pricing Complexity"
                    [required]="true"
                    name="pricingComplexityId"
                    labelProp="complexity"
                    (change)="pricingComplexityChanged()"
                    [(ngModel)]="mappedItem.pricingComplexityId"
                    [options]="pricingComplexities$ | async"
                >
                </cb-select>
            }
            <cb-input
                type="number"
                name="targetWorkHours"
                label="Estimated Hours"
                [(ngModel)]="mappedItem.targetWorkHours"
            >
            </cb-input>
            <cb-datepicker name="dueByDate" [(ngModel)]="mappedItem.dueBy" label="Due By">
            </cb-datepicker>
        </div>
    </form>
    <div actions class="flex flex-row center-right">
        <cb-button
            [disabled]="form.pristine || form.invalid"
            [clickLimit]="1"
            class="cb-margin-right"
            (clicked)="save()"
        >
            Save
        </cb-button>
        <cb-button (clicked)="cancel()"> Cancel </cb-button>
    </div>
</cb-dialog>
